import { DOCUMENT_CATEGORY_ENUM, I18N_LOCALE_TO_DOCUMENT_LOCALE, IDocument, IRevision } from "../@types/document";
import { IProductCrm } from "../@types/product";

export enum ActionTypes {
    ChangeCategory,
    SetDocs,
    SetProduct,
    SetProductProp,
    SetSpecificDoc
}

export interface ChangeCategory {
    type: ActionTypes.ChangeCategory;
    payload: DOCUMENT_CATEGORY_ENUM;
}

export interface SetDocs {
    type: ActionTypes.SetDocs;
    payload: IDocument[];
}

export interface SetProduct {
    type: ActionTypes.SetProduct;
    payload: IProductCrm;
}

export interface SetSpecificDoc {
    type: ActionTypes.SetSpecificDoc;
    payload: IDocument;
}

export interface SetProductProp {
    type: ActionTypes.SetProductProp;
    propName: string;
    propValue: string;
}

export type AppActions = ChangeCategory | SetDocs | SetProduct | SetProductProp | SetSpecificDoc;